var LayoutPerspective = require('./../layout/LayoutPerspective');
var QuestionnaireWidget = require('./../questionnaire/QuestionnaireWidget');
var wizardPerspectiveTemplate = require('./../wizard/wizardPerspectiveTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');
var launcherAppInterface = require('./../launcherApplicationInterface');

var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');

/**
 * Perspective to display the Appointment Questionnaire page
 *
 * @class AppointmentQuestionnairePerspective
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = LayoutPerspective.extend({
  template: wizardPerspectiveTemplate,
  moduleNamespace: 'appointmentQuestionnairePerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'aside.information.header',
      asideContentMessageKey: launcherAppInterface.isAtHospital() ? 'prereg.surveys.aside.ereg' : 'prereg.surveys.aside'
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.SURVEYS,
      initialLoadingMessage: $.i18n.prop('wizard.buttons.loading')
    },
    appointmentSecureMessage: {
      behavior: SecureMessageDataBehavior,
      returnSingleResult: true,
      ids: function(cache) {
        var appointmentExternalId = this.view._appointmentExternalId;
        if (!appointmentExternalId) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._patientVecnaId;
        var criteria = cache.getCriteriaForAppointmentIdAndExternalId(patientVecnaId, appointmentExternalId);
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: { property: 'behaviors.appointmentSecureMessage.data:appointmentDTO.externalAppointment.type'}
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the current appointments being preregistered for
   *   @param options.questionnaireName {String} the name of the questionnaire to display.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this._questionnaireWidget = new QuestionnaireWidget({
      patientVecnaId: options.patientVecnaId,
      appointmentExternalId: options.appointmentExternalId,
      questionnaireName: options.questionnaireName,
      regDate: options.regDate
    });
    this.getBehavior('wizardPerspectiveBehavior').setContentView(this._questionnaireWidget);
  },

  /**
   * Reinitializes questionnaire widget
   * @method reinitializeQuestionnaire
   * @param options {Object} Options to initialize the questionnaire widget
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param options.questionnaireName {String} the name of the questionnaire to display.
   */
  initializeQuestionnaire: function(options) {
    this._questionnaireWidget.initialize(options);
  }
});
